<app-hr-page-header
  [heading]="headingEmployee"
  [searchPlaceholder]="'Search employees'"
  [addButtonText]="'Add Employee'"
  [exportButtonText]="'Export'"
  [initialSearchQuery]="searchQuery"
  [showFilterIcon]="true"
  (searchInput)="onSearchInput($event)"
  (searchFocus)="openFilterDialog()"
  (addClick)="addEmployee()"
  (exportClick)="exportEmployees()"
  (filterClick)="openFilterDialog()"
></app-hr-page-header>

<div class="hr-table-container">
  <!-- Show table when there is data -->
  <div class="table-responsive" [ngClass]="{ 'no-data': !employeedata || employeedata.length === 0 }">
    <table class="table" id="emp_expense">
      <thead>
        <tr>
          <th>Employee ID</th>
          <th>Employee Name</th>
          <th>Email</th>
          <th>Gender</th>
          <th>Status</th>
          <th>Earned Leaves</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let emp of employeedata; let i = index">
          <td>{{ emp.emp_id }}</td>
          <td>{{ emp.name | titlecase }}</td>
          <td>{{ emp.email }}</td>
          <td>{{ emp.gender | titlecase }}</td>
          <td>{{ is_Disabled(emp.is_disabled) }}</td>
          <td>{{ emp.earned_leaves }}</td>
          <td>
            <span class="action-link" (click)="openUserProfile(emp)">
              Edit
              
              <!-- <img class="arrow-image" src="../../../assets/images/arrows.svg" alt="">
            -->
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Show no-data state when no employees -->
  <div class="no-data-container" *ngIf="!employeedata || employeedata.length === 0">
    <img src="../../../assets/images/no-data.svg" alt="No data found">
    <h3>No Data Found</h3>
    <p>No employees found</p>
  </div>
</div>

<div class="page_div" [ngClass]="{ 'hide-pagination': !employeedata || employeedata.length === 0 }">
  <div class="row" id="pagination-container">
    <div class="col-sm-4 float-left">
      Current Page {{ this.currentPage }} Total Number of Pages
      {{ this.totalPages }}
    </div>
    <div class="col-sm-8">
<div class="float-start">
    
      <button
      (click)="firstPage()"
      class="btn custom-btn"
      [disabled]="this.currentPage === 1"
    >
      | <
    </button>

      <button
        (click)="previousPage()"
        class="btn custom-btn"
        [disabled]="this.currentPage === 1"
      >
         <
      </button>
      <ng-container *ngIf="totalPages > 0">
        <button
          *ngFor="let page of getNumericButtons()"
          (click)="gotoPage(page)"
          class="btn custom-btn"
          [class.active]="page === currentPage"
        >
          {{ page }}
        </button>
      </ng-container>
  
      <button
        (click)="nextPage()"
        class="btn custom-btn"
        [disabled]="this.currentPage === this.totalPages"
      >
        > 
      </button>


          <button
  (click)="lastPage()"
  class="btn custom-btn"
  [disabled]="this.currentPage === this.totalPages"
>
  > |
</button>


      </div>
    </div>
  </div>
</div>